/**
 * The question mark that carries an explanation.
 *
 * Panels used to explain themselves in paragraphs, which is fine the first time
 * somebody meets a feature and is in the way every time after. The words are
 * the same; they are just folded behind a mark beside whatever they are about,
 * so the panel reads as a set of options rather than as a manual.
 */

export function Explain({ children }: { children: string }): JSX.Element {
  return (
    <button
      type="button"
      className="explain"
      title={children}
      aria-label={children}
      // Out of the tab order: it does nothing when pressed, and tabbing through
      // a form should reach the fields rather than the footnotes.
      tabIndex={-1}
      onClick={(event) => event.preventDefault()}
    >
      ?
    </button>
  );
}
